module.exports = __webpack_public_path__ + "static/media/watermelon.f61af6fd.gif";